<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->

<form *ngIf="formGroup" [formGroup]="formGroup">
    <mat-card appearance="raised">
        <mat-card-header>
            <mat-card-title>
                {{'policy.bitlocker.general-settings.title' | translate}}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>
                <mat-checkbox formControlName="backupKeyToManagementConsole" (change)="onDataChanged()">{{'policy.bitlocker.general-settings.backup-recovery-key-to-m-c' | translate}}</mat-checkbox>
            </div>
            <div>
                <mat-checkbox formControlName="backupKeyToActiveDirectory" (change)="onDataChanged()">{{'policy.bitlocker.general-settings.backup-recovery-key-to-a-d' | translate}}</mat-checkbox>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card appearance="raised">
        <mat-card-header>
            <mat-card-title>
                {{'policy.bitlocker.os-drive.title' | translate}}
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.manage-bitlocker-encryption' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="osDriveManageBitlockerEncryption" (selectionChange)="onDataChanged()">
                            <mat-option [value]="BitLockerEncryption.doNotManage">
                              {{'policy.bitlocker.general-settings.encryption-do-not-manage' | translate}}
                            </mat-option>
                            <mat-option [value]="BitLockerEncryption.turnOnEncryption">
                              {{'policy.bitlocker.general-settings.encryption-turn-on' | translate}}
                            </mat-option>
                            <mat-option [value]="BitLockerEncryption.turnOffEncryption">
                              {{'policy.bitlocker.general-settings.encryption-turn-off' | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>
                    <mat-checkbox formControlName="osDriveRequireStartupAuth" (change)="onDataChanged()">{{'policy.bitlocker.os-drive.require-startup-auth' | translate}}</mat-checkbox>
                </div>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="osDriveStartupAuthType" (selectionChange)="onDataChanged()">
                        <mat-option [value]="StartupAuthType.tpmOnly">{{'policy.bitlocker.os-drive.require-startup-auth-tpm-only' | translate}}</mat-option>
                        <mat-option [value]="StartupAuthType.tpmWithPIN">{{'policy.bitlocker.os-drive.require-startup-auth-tpm-with-pin' | translate}}</mat-option>
                        <mat-option [value]="StartupAuthType.tpmWithStartupKey">{{'policy.bitlocker.os-drive.require-startup-auth-tpm-with-startup-key' | translate}}</mat-option>
                        <mat-option [value]="StartupAuthType.tpmWithPINAndStartup">{{'policy.bitlocker.os-drive.require-startup-auth-tpm-with-pin-and-startup-key' | translate}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
<!--            Will bring back in the future
            <div>
                <mat-checkbox formControlName="osDriveAllowBitlockerWithoutCompatibleTPM" (change)="onDataChanged()">{{'policy.bitlocker.os-drive.allow-without-compatible-tpm' | translate}}</mat-checkbox>
            </div>-->

            <div>
                <div>
                    <mat-checkbox formControlName="osDriveConfigurePreBootRecoveryMessage" (change)="onDataChanged()">{{'policy.bitlocker.os-drive.pre-boot-recovery-title' | translate}}</mat-checkbox>
                </div>
                <div class="sub-control">
                    <mat-form-field appearance="outline" class="sub-control-text-input">
                        <mat-label>{{'policy.bitlocker.os-drive.pre-boot-recovery-message' | translate}}</mat-label>
                      <textarea matInput formControlName="osDrivePreBootRecoveryMessage" (input)="onDataChanged()" maxlength="900"></textarea>
                    </mat-form-field>
                </div>
                <div class="sub-control">
                    <mat-form-field appearance="outline" class="sub-control-text-input recovery-message-input">
                        <mat-label>{{'policy.bitlocker.os-drive.pre-boot-recovery-url' | translate}}</mat-label>
                        <input type="text" formControlName="osDrivePreBootRecoveryURL" matInput (input)="onDataChanged()" maxlength="500" />
                    </mat-form-field>
                </div>
            </div>

            <mat-card-title class="non-header-title">{{'policy.bitlocker.os-drive.recovery.title' | translate}}</mat-card-title>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.package' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="osDriveRecoveryPackage" (selectionChange)="onDataChanged()">
                            <mat-option [value]="RecoveryPackage.passwordAndKey">{{'policy.bitlocker.os-drive.recovery.package-password-and-key' | translate}}</mat-option>
                            <mat-option [value]="RecoveryPackage.passwordOnly">{{'policy.bitlocker.os-drive.recovery.package-password-only' | translate}}</mat-option>
                            <!--                        <mat-option [value]="RecoveryPackage.keyOnly">{{'policy.bitlocker.os-drive.recovery.package-key-only' | translate}}</mat-option>-->
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.key-file-creation' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="osDriveRecoveryKeyFileCreation" (selectionChange)="onDataChanged()">
                            <mat-option [value]="RecoveryKeyFileCreation.allowed">{{'policy.bitlocker.os-drive.recovery.key-file-creation-allowed' | translate}}</mat-option>
                            <mat-option [value]="RecoveryKeyFileCreation.disabled">{{'policy.bitlocker.os-drive.recovery.key-file-creation-disabled' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.password-file-creation' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="osDriveRecoveryPasswordFileCreation" (selectionChange)="onDataChanged()">
                            <mat-option [value]="RecoveryPasswordFileCreation.allowed">{{'policy.bitlocker.os-drive.recovery.password-file-creation-allowed' | translate}}</mat-option>
                            <mat-option [value]="RecoveryPasswordFileCreation.disabled">{{'policy.bitlocker.os-drive.recovery.password-file-creation-disabled' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.minimum-pin-length' | translate}}</div>
                <div style="height: 57px;">
                    <app-numeric-input min="6" max="20" step="1" [showProgressBar]="false" [showMinMax]="false"
                                       [value]="osDriveMinimumPINLength"
                                       [inputLabelStyles]="numericInputLabelStyles"
                                       (valueChanged)="osDriveMinPINChanged($event)"></app-numeric-input>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.encryption-type' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="osDriveEncryptionType" (selectionChange)="onDataChanged()">
                            <mat-option [value]="EncryptionType.usedSpaceOnly">{{'policy.bitlocker.os-drive.recovery.encryption-type-used-only' | translate}}</mat-option>
                            <mat-option [value]="EncryptionType.fullEncryption">{{'policy.bitlocker.os-drive.recovery.encryption-type-full' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.encryption-method' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="osDriveEncryptionMethod" (selectionChange)="onDataChanged()">
                            <mat-option [value]="EncryptionMethod.aesCbc128">AES-CBC 128-bit</mat-option>
                            <mat-option [value]="EncryptionMethod.aesCbc256">AES-CBC 256-bit</mat-option>
                            <mat-option [value]="EncryptionMethod.xtsAes128">XTS-AES 128-bit</mat-option>
                            <mat-option [value]="EncryptionMethod.xtsAes256">XTS-AES 256-bit</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div>
                <mat-checkbox formControlName="osDriveDisallowStandardUsersChangingAuth" (change)="onDataChanged()">{{'policy.bitlocker.os-drive.recovery.disallow-standard-user-changing-pin' | translate}}</mat-checkbox>
            </div>

            <div>
                <mat-checkbox formControlName="osDriveAllowEnhancedPINSForStartup" (change)="onDataChanged()">{{'policy.bitlocker.os-drive.recovery.allow-enhanced-pins-for-startup' | translate}}</mat-checkbox>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card appearance="raised">
        <mat-card-header>
            <mat-card-title>{{'policy.bitlocker.os-drive.fixed-data-drives' | translate}}</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.manage-bitlocker-encryption' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="dataDrivesManageBitlockerEncryption" (selectionChange)="onDataChanged()">
                            <mat-option [value]="BitLockerEncryption.doNotManage">Do not manage</mat-option>
                            <mat-option [value]="BitLockerEncryption.turnOnEncryption">Turn on encryption</mat-option>
                            <mat-option [value]="BitLockerEncryption.turnOffEncryption">Turn off encryption</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

          <div class="auto-unlock-checkbox">
            <mat-checkbox formControlName="dataDriveAutoUnlock">Auto unlock</mat-checkbox>
          </div>

            <mat-card-title class="non-header-title">{{'policy.bitlocker.os-drive.recovery.title' | translate}}</mat-card-title>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.package' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="dataDrivesRecoveryPackage" (selectionChange)="onDataChanged()">
                            <mat-option [value]="RecoveryPackage.passwordAndKey">{{'policy.bitlocker.os-drive.recovery.package-password-and-key' | translate}}</mat-option>
                            <mat-option [value]="RecoveryPackage.passwordOnly">{{'policy.bitlocker.os-drive.recovery.package-password-only' | translate}}</mat-option>
                            <!--                        <mat-option [value]="RecoveryPackage.keyOnly">{{'policy.bitlocker.os-drive.recovery.package-key-only' | translate}}</mat-option>-->
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.key-file-creation' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="dataDrivesRecoveryKeyFileCreation" (selectionChange)="onDataChanged()">
                            <mat-option [value]="RecoveryKeyFileCreation.allowed">{{'policy.bitlocker.os-drive.recovery.key-file-creation-allowed' | translate}}</mat-option>
                            <mat-option [value]="RecoveryKeyFileCreation.disabled">{{'policy.bitlocker.os-drive.recovery.key-file-creation-disabled' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.password-file-creation' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="dataDrivesRecoveryPasswordFileCreation" (selectionChange)="onDataChanged()">
                            <mat-option [value]="RecoveryPasswordFileCreation.allowed">{{'policy.bitlocker.os-drive.recovery.password-file-creation-allowed' | translate}}</mat-option>
                            <mat-option [value]="RecoveryPasswordFileCreation.disabled">{{'policy.bitlocker.os-drive.recovery.password-file-creation-disabled' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.encryption-type' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="dataDrivesEncryptionType" (selectionChange)="onDataChanged()">
                            <mat-option [value]="EncryptionType.usedSpaceOnly">{{'policy.bitlocker.os-drive.recovery.encryption-type-used-only' | translate}}</mat-option>
                            <mat-option [value]="EncryptionType.fullEncryption">{{'policy.bitlocker.os-drive.recovery.encryption-type-full' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="left-right">
                <div>{{'policy.bitlocker.os-drive.recovery.encryption-method' | translate}}</div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="dataDrivesEncryptionMethod" (selectionChange)="onDataChanged()">
                            <mat-option [value]="EncryptionMethod.aesCbc128">AES-CBC 128-bit</mat-option>
                            <mat-option [value]="EncryptionMethod.aesCbc256">AES-CBC 256-bit</mat-option>
                            <mat-option [value]="EncryptionMethod.xtsAes128">XTS-AES 128-bit</mat-option>
                            <mat-option [value]="EncryptionMethod.xtsAes256">XTS-AES 256-bit</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

        </mat-card-content>
    </mat-card>
</form>



